var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{staticClass:"a",attrs:{"d":"M5,0H15a2.08,2.08,0,0,1,2,2V18a2.08,2.08,0,0,1-2,2H5a2.08,2.08,0,0,1-2-2V14H5v2H15V2H5V4H3V2A2.08,2.08,0,0,1,5,0Zm5,19a1,1,0,1,0-1-1A1,1,0,0,0,10,19Z"}}),_c('path',{attrs:{"d":"M7,8H0v2H7v3l4-4L7,5Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }